import * as type from './types'
import i18n from 'vue-i18n'

const actions = {
  initWrldUser({ commit }) {
    if (navigator.language === 'cs' || navigator.language === 'cs-CZ' ||
    navigator.language === 'sk' || navigator.language === 'sk-SK'
    ) {
      i18n.locale = 'cs'
    }
    const defaultUser = {
      lang: 'cs'
    }
    let user = null
    try {
      const localUser = localStorage.getItem('user')
      user = { ...defaultUser, ...JSON.parse(localUser) }
    } catch (error) {
      console.error(error)
    }
    localStorage.setItem('user', JSON.stringify(user))
    commit(type.SET_WRLD_USER_LANG, { lang: user.lang })
  },
  setWrldUserLang({ commit }, { lang }) {
    commit(type.SET_WRLD_USER_LANG, { lang })
    try {
      const localUser = JSON.parse(localStorage.getItem('user'))
      if (localUser != null) {
        localStorage.setItem('user', JSON.stringify({ ...localUser, lang }))
      }
    } catch (error) {
      console.error(error)
    }
  },
}
export default actions
